import TopBanner from 'components/TopBanner'
import { ProblemList } from 'components/TopBanner/OrderTriageTopBanner'

export const OrderWarningTopBanner = ({ messages }: { messages: string[] }): JSX.Element => {
  return messages.length ? (
    messages.length === 1 ? (
      <TopBanner message={messages[0]} />
    ) : (
      <TopBanner message="There are problems with this order">
        <ProblemList>
          {messages.map((message, i) => (
            <li key={i}>{message}</li>
          ))}
        </ProblemList>
      </TopBanner>
    )
  ) : (
    <></>
  )
}
